module.exports = __webpack_public_path__ + "static/media/oasis_cube_shop1.d429589b.webp";